import React, { useState } from "react";
import {sendVerifyEmail, sendResetPasswordEmail} from "utilities/js/callouts/CalloutFactory";
import './AccountSettingsTab_General.css';
import AccountInfoScreenCard from "./AccountInfoScreenCard";
import ColorSelectionCard from "./ColorSelectionCard";
import { navigateToContactUsPage, navigateToForgotPasswordPage } from "utilities/js/NavigationHelper";
import { useNavigate } from "react-router-dom";
import {logout} from "utilities/js/ActionLibrary";



const AccountSettingsTab_General = (props) => {

    const [resendEmailDisabled, setResendEmailDisabled] = useState(false);
    const label = 'General Settings';

    const navigate = useNavigate();
    const dateJoined = props.userInfo.created_date ? new Date(parseInt(props.userInfo.created_date)).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}) : '';


    function sendEmailVerification(){
        setResendEmailDisabled(true);

        sendVerifyEmail().then(response => {
            console.log('email sent successfully');
            //TODO: Show Toast
        }).catch(error => {
            console.log('cound not send email');
            console.log(error);
            setResendEmailDisabled(false);
        }).finally(() => {

        });
    }

    function openContactUsScreen(){
        navigateToContactUsPage({routerNav: navigate});
    }

    function openForgotPasswordScreen(){
        navigateToForgotPasswordPage({routerNav: navigate});
    }   


    function getAccountInfoScreen(){
        let emailCard = (
            <AccountInfoScreenCard 
                label="Email" 
                content={(<><div className="account-info-name">{props.userInfo.email}</div><div className="warning-text">You have not yet verified your email.  Certain operations require a verified email.</div></>)}
                actions={(<div className="email-verified-prompt"><button className="account-info-card-button" disabled={resendEmailDisabled} onClick={sendEmailVerification}>Resend Email</button></div>)}
            ></AccountInfoScreenCard>
        );

        if(props.userInfo.email_verified){
            
            emailCard = (
                <AccountInfoScreenCard 
                    label="Email" 
                    content={(<div className="account-info-name">{props.userInfo.email}</div>)}
                ></AccountInfoScreenCard>
            );
        }

        return (
            <>
                <div className="account-info-label hide-desktop">{label}</div>
                <AccountInfoScreenCard 
                    label={props.userInfo.username} 
                    content={(
                        <>
                        <div className="account-info-name">{props.userInfo.first_name} {props.userInfo.last_name}</div>
                        <div className="premium-indicator">{props.userInfo.premium}</div></>
                    )}
                    actions={(<div className="email-verified-prompt"><button className="nav-button-red" onClick={logout}>Log Out</button></div>)}
                ></AccountInfoScreenCard>

                {emailCard}
                
                <AccountInfoScreenCard 
                    label="Join Date" 
                    content={(<div className="date-joined">
                        {dateJoined}
                    </div>)}
                ></AccountInfoScreenCard>

                <ColorSelectionCard 
                    userInfo={props.userInfo} 
                    updateSetting={props.updateSetting} 
                    mode={props.mode} 
                    allowableColors={props.allowableColors}
                ></ColorSelectionCard>


                <AccountInfoScreenCard 
                    label="Sign up for Premium" 
                    content={(<div className="screen-card-subtext">Note: Premium is not yet available.  Let us know about your interest</div>)}
                    actions={(<button className="nav-button" onClick={openContactUsScreen}>Contact Us</button>)}
                ></AccountInfoScreenCard>

                <AccountInfoScreenCard 
                    label="Reset Password" 
                    content={(<></>)}
                    actions={(<button className="nav-button-red" onClick={openForgotPasswordScreen}>Reset Password</button>)}
                ></AccountInfoScreenCard>
                
            </>

        );
    }


    return (
        <>
            {getAccountInfoScreen()}                
        </>
    );
    
}

export default AccountSettingsTab_General;



// class AccountSettingsTab_General extends React.Component {

//     constructor(props){
//         super(props);
//         this.state = {
//             username: this.props.userInfo.username ? this.props.userInfo.username : '',
//             firstName: this.props.userInfo.first_name ? this.props.userInfo.first_name : '',
//             lastName: this.props.userInfo.last_name ? this.props.userInfo.last_name : '',
//             email: this.props.userInfo.email ? this.props.userInfo.email : '',
//             isPremium: this.props.userInfo.premium ? this.props.userInfo.premium : '',
//             dateJoined: this.props.userInfo.created_date ? new Date(parseInt(this.props.userInfo.created_date)).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}) : '',
//             isEmailVerified: this.props.userInfo.email_verified ? this.props.userInfo.email_verified : '',
//             resendEmailDisabled: false,
//             label: 'General Settings'
//         };

//         this.getAccountInfoScreen = this.getAccountInfoScreen.bind(this);
//         this.logout = this.logout.bind(this);
//         this.sendEmailVerification = this.sendEmailVerification.bind(this);
//         this.openForgotPasswordScreen = this.openForgotPasswordScreen.bind(this);
           
//     }

//     sendEmailVerification(){
//         this.setState({resendEmailDisabled:true});
//         sendVerifyEmail().then(response => {
//             console.log('email sent successfully');
//             //TODO: Show Toast
//         }).catch(error => {
//             console.log('cound not send email');
//             console.log(error);
//             this.setState({resendEmailDisabled:false});
//         }).finally(() => {

//         });
//     }

//     openForgotPasswordScreen(){
//         navigateToForgotPasswordPage();
//     }

//     openForgotPasswordScreen(){
//         navigateToContactUsPage();
//     }
    
//     logout(){
//         console.log('logging out...');
//         cookieManager.clearAllValues();
//         setRecentViewBackets(null);
//         setRecentCreateBackets(null);
//         navigateToLandingPage({routerNav: this.props.navigate});
//     }
    


//     getAccountInfoScreen(){
//         let emailCard = (
//             <AccountInfoScreenCard 
//                 label="Email" 
//                 content={(<><div className="account-info-name">{this.state.email}</div><div className="warning-text">You have not yet verified your email.  Certain operations require a verified email.</div></>)}
//                 actions={(<div className="email-verified-prompt"><button className="account-info-card-button" disabled={this.state.resendEmailDisabled} onClick={this.sendEmailVerification}>Resend Email</button></div>)}
//             ></AccountInfoScreenCard>
//         );

//         if(this.state.isEmailVerified){
            
//             emailCard = (
//                 <AccountInfoScreenCard 
//                     label="Email" 
//                     content={(<div className="account-info-name">{this.state.email}</div>)}
//                 ></AccountInfoScreenCard>
//             );
//         }

//         return (
//             <>
//                 <div className="account-info-label hide-desktop">{this.state.label}</div>
//                 <AccountInfoScreenCard 
//                     label={this.state.username} 
//                     content={(
//                         <>
//                         <div className="account-info-name">{this.state.firstName} {this.state.lastName}</div>
//                         <div className="premium-indicator">{this.state.isPremium}</div></>
//                     )}
//                     actions={(<div className="email-verified-prompt"><button className="nav-button-red" onClick={this.logout}>Log Out</button></div>)}
//                 ></AccountInfoScreenCard>

//                 {emailCard}
                
//                 <AccountInfoScreenCard 
//                     label="Join Date" 
//                     content={(<div className="date-joined">
//                         {this.state.dateJoined}
//                     </div>)}
//                 ></AccountInfoScreenCard>

//                 <ColorSelectionCard 
//                     userInfo={this.props.userInfo} 
//                     updateSetting={this.props.updateSetting} 
//                     mode={this.props.mode} 
//                     allowableColors={this.props.allowableColors}
//                 ></ColorSelectionCard>


//                 <AccountInfoScreenCard 
//                     label="Sign up for Premium" 
//                     content={(<div className="screen-card-subtext">Note: Premium is not yet available.  Let us know about your interest</div>)}
//                     actions={(<button className="nav-button" onClick={this.openContactUsScreen}>Contact Us</button>)}
//                 ></AccountInfoScreenCard>

//                 <AccountInfoScreenCard 
//                     label="Reset Password" 
//                     content={(<></>)}
//                     actions={(<button className="nav-button-red" onClick={this.openForgotPasswordScreen}>Reset Password</button>)}
//                 ></AccountInfoScreenCard>
                
//             </>

//         );
//     }

//     render(){

//         return (
//             <>
//                 {this.getAccountInfoScreen()}                
//             </>
//         );
//     }
// }

// export default NavigatorWrapper(AccountSettingsTab_General);
